import React, {Component} from 'react';
import {connect} from 'react-redux';
import {newSendEmail, resetContactByEmail} from "../../actions/actionsContactByEmail";

import Alert from 'react-s-alert';


class NewV2ContactComponent extends Component {
    
    constructor(props) {
        super(props);
        // console.log("ContactEntityComponent::constructor()");
        
        this.state = {
            optionsEmail: {
                nombre: "",
                email: "",
                mensaje: "",
            },
            showLoader: false
        }
        
        this.handleChange = this.handleChange.bind(this);
        this.onSendEmail = this.onSendEmail.bind(this);
        this.onCLickHideEmail = this.onCLickHideEmail.bind(this);
        this.onClickEmailButton = this.onClickEmailButton.bind(this);
        this.onClickWhatsappButton = this.onClickWhatsappButton.bind(this);
        this.sendEventWhatsapp = this.sendEventWhatsapp.bind(this);
        
        // this.props.configEstadoContacto.methodChange = this.changeAsunto.bind(this);
    }
    
    changeAsunto(asunto) {
        if (asunto !== undefined) {
            this.props.changeAsunto(asunto[0], this.props.animalsControl);
        }
    }
    
    handleChange(event) {
    
    }
    
    
    onClickEmailButton() {
        // this.props.changeModeEmail(true, this.props.animalsControl);
        this.toggleModalContacByEmail()
    }
    
    
    toggleModalContacByEmail() {
        $('#modalContacByEmail').modal('toggle')
        $('#modalContacByEmail').modal('show')
    }
    
    onClickLlamar() {
        console.log("Not implemented yet");
    }
    
    onClickWhatsappButton() {
        const infoEntity = this.props.infoAnimalDetail.protectora || this.props.infoProtectoraDetail
        const colaboradores = infoEntity.colaboradores.filter((telefono) => {
            return telefono.WhatsApp
        });
        if (colaboradores.length === 0) {
            Alert.info('Esta protectora no tiene whatsapp :(', {
                position: 'top-right',
                effect: 'slide',
                timeout: 6000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "lab la-whatsapp la-2x"
                }
            });
        } else {
            Alert.info('Seleccione el número', {
                position: 'bottom-right',
                effect: 'slide',
                timeout: 'none',
                customFields: {
                    messageItem: 4,
                    showIconClosed: true,
                    icon: "lab la-whatsapp la-2x",
                    colaboradores: colaboradores,
                    methodWhatsapp: this.sendEventWhatsapp,
                    messageWhatsApp: this.props.configEstadoContacto.messageWhatsapp,
                    urlWhatsApp: this.props.urlWhastapp
                }
            });
        }
    }
    
    sendEventWhatsapp(number) {
        // const mensage = "Quiero más información sobre "+ this.props.infoAnimalDetail.nombre
        // const urlWhats = number
        //     ? "https://wa.me/34" + number + "?text=" + this.props.configEstadoContacto.messageWhatsapp + "%20" + this.props.urlWhastapp
        //     : "https://wa.me/?text=" + this.props.configEstadoContacto.messageWhatsapp + "%20" + this.props.urlWhastapp;
        //
        // window.open(urlWhats);
    }
    
    validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase().trim());
    }
    onCLickHideEmail(){
        this.props.onCloseModal()
    }
    onSendEmail(e) {
        //Comprobar que todos los campos son correctos.
        let errorMessage = "";
        let nombreText = document.getElementsByClassName("formNombre")[0]
        let emailText = document.getElementsByClassName("formEmail")[0]
        let mensajeText = document.getElementsByClassName("formMensaje")[0]
        let nombre = $('.formNombre');
        let email = $('.formEmail');
        let mensaje = $('.formMensaje');
        
        if (nombre.val() === "") {
            nombre.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Nombre";
            } else {
                errorMessage += ", nombre";
            }
        } else {
            nombre.removeClass('formInputError')
        }
        
        if (email.val() === "") {
            email.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Email";
            } else {
                errorMessage += ", email";
            }
        } else {
            if (!this.validateEmail(email.val().trim())) {
                email.removeClass('formInputError').addClass('formInputError');
                if (errorMessage === "") {
                    errorMessage = "Email no válido";
                } else {
                    errorMessage += ", email no válido";
                }
            } else {
                email.removeClass('formInputError')
            }
        }
        
        if (mensaje.val() === "") {
            mensaje.removeClass('formInputError').addClass('formInputError');
            if (errorMessage === "") {
                errorMessage = "Mensaje";
            } else {
                errorMessage += ", mensaje";
            }
        } else {
            mensaje.removeClass('formInputError')
        }
        
        Alert.closeAll();
        if (errorMessage !== "") {
            e.preventDefault();
            Alert.warning('Los siguientes campos son obligatorios: ' + errorMessage, {
                position: 'top-right',
                effect: 'slide',
                timeout: 'none',
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "las la-2x la-exclamation-triangle"
                }
            });
        } else {
    
            const info = {
                nombre: nombre.val(),
                email: email.val(),
                mensaje: mensaje.val(),
                idProtectora: this.props.infoProtectoraDetail._id,
                idAnimal: (this.props.infoAnimalDetail && this.props.infoAnimalDetail._id)?this.props.infoAnimalDetail._id:undefined,
                tipo: this.props.tipoContacto
            }
            this.props.newSendEmail(info)
            this.setState({showLoader: true})
            this.props.onClickSendEmail()
            e.preventDefault();
        }
    }
    
    
    manageContactByEmail() {
        const result = this.props.contactByEmail;
        if (result && result.response && result.response.status === "ok") {
            Alert.success('Enviado correctamente', {
                position: 'top-right',
                effect: 'slide',
                timeout: 6000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "las la-2x la-thumbs-up"
                }
            });
            this.props.resetContactByEmail();
            
            // this.setState({showLoader: false})
            this.toggleModalContacByEmail()
            
        } else if (result && result.errorSendEmail) {
            Alert.error('Error: ' + result.errorSendEmail, {
                position: 'top-right',
                effect: 'slide',
                timeout: 6000,
                customFields: {
                    messageItem: 2,
                    showIconClosed: true,
                    icon: "las la-2x la-exclamation-triangle"
                }
            });
            this.props.resetContactByEmail();
            
        }
    }
    
    
    render() {
        // console.log("ContactEntityComponent::render()");
        return (
            <div className="">
                <h4>{this.props.title || "Pedir información"}</h4>
                <div className="contact-mode">
                    <div className="informationDetail informationDetailHeader ">
                        <ul>
                            {/*<li onClick={this.onClickLlamar}>*/}
                            {/*    <span className="las la-3x la-phone"/><span*/}
                            {/*    className="sexo-data">Llamar</span>*/}
                            {/*</li>*/}
                            {/*<li onClick={this.onClickWhatsappButton}>*/}
                            {/*    <span className="lab la-3x la-whatsapp"/><span*/}
                            {/*    className="sexo-data">WhatsApp</span>*/}
                            {/*</li>*/}
                            <li onClick={this.onClickEmailButton}>
                                <span className="las la-3x la-envelope"/>
                                <span className="edad-data">Email</span>
                            </li>
                        </ul>
                    </div>
                </div>
                
                <div className="modal fade"  id="modalContacByEmail" role="dialog"
                     aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLongTitle">Contacto por email
                                    con <strong>{this.props.infoProtectoraDetail.nombre}</strong></h6>
                            </div>
                            <div className="modal-body">
                                {/*<div className="headContactEmailLeft">*/}
                                {/*    <img src={url_imagen} alt="" className="embed-responsive imagenContactEmail"/>*/}
                                {/*</div>*/}
                                <div className="form-group row">
                                    {/*<label htmlFor="example-text-input-with-left-icon" className="col-3 col-form-label">Nombre: </label>*/}
                                    <div className="col-9 input-form-contact-email">
                                        <div className="form-control-inline-icon inline-icon-left">
                                            <div className="contentIconContactEmail">
                                                <span className="iconContactEmail las la-lg la-user"></span>
                                            </div>
                                            <input id="example-text-input-with-left-icon" type="text"
                                                   onChange={this.handleChange}
                                                   className="form-control form-control-2 formNombre"
                                                   placeholder="Tu nombre"/>
                                        </div>
                                    </div>
                                
                                </div>
                                <div className="form-group row">
                                    {/*<label htmlFor="example-text-input-with-left-icon" className="col-3 col-form-label">Email: </label>*/}
                                    <div className="col-9 input-form-contact-email">
                                        <div className="form-control-inline-icon inline-icon-left">
                                            <div className="contentIconContactEmail">
                                                <span className="iconContactEmail las la-lg la-at"></span>
                                            </div>
                                            <input id="example-text-input-with-left-icon" type="text"
                                                   onChange={this.handleChange}
                                                   className="form-control form-control-2 formEmail"
                                                   placeholder="Email"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="informationDetail">
                                    <div className="form-group row">
                                        <div className="col-12">
                                            <textarea id="mensaje_email" className="form-control formMensaje"
                                                      onChange={this.handleChange}
                                                      placeholder="Escribe tu mensaje" rows="10"/>
                                        </div>
                                    </div>
                                </div>
                                <div className="informationDetail ">
                                    <div className="form-group row botones_email">
                                        <button id="atras_email"
                                                className="btn btn-outline-primary listing-houses__item-view-link atras_email"
                                                type="button" data-dismiss="modal">Atrás
                                        </button>
                                        <button onClick={this.onSendEmail} id=""
                                                className="btn btn-outline-primary listing-houses__item-view-link enviar_email">Enviar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            </div>
                        </div>
                    </div>
                </div>
                
                {/*{this.state.showLoader &&*/}
                {/*<LoaderWait*/}
                {/*    message={"Enviando email..."}*/}
                {/*/>}*/}
            
            </div>
        
        );
    }
    
    componentDidMount() {
        $('.contactStep2').show();
        
        $(window).on('popstate', function () {
            $('#modalContacByEmail').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        });
        
        const that = this
        $('#modalContacByEmail').on('hidden.bs.modal', function () {
            that.props.onCloseModal()
        })
        
    }
    
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.contactByEmail && (this.props.contactByEmail.response || this.props.contactByEmail.errorSendEmail)) {
            this.manageContactByEmail()
        }
        
        if (this.props.showModalContactByEmail) {
            this.toggleModalContacByEmail()
        }else{
            // document.getElementById("atras_email").click()
            // this.props.onCloseModal()
        }
        
        
        
    }
    
    
}

function mapStateToProps(state, ownProps) {
    return {
        contactByEmail: state.contactByEmail,
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {resetContactByEmail, newSendEmail})(NewV2ContactComponent)
